<script>
import '@/util/dark-mode'
import AppServiceWorkerManager from './AppServiceWorkerManager.vue'

const title = 'Kibun'

export default {
  components: {
    AppServiceWorkerManager,
  },

  metaInfo: {
    title,
    titleTemplate: t => t === title ? `${t} - Share your status in one click` : `${t} - ${title}`,
    meta: [
      {
        property: 'og:title',
        content: 'Kibun',
        vmid: 'og:title',
      },
      {
        property: 'og:description',
        content: 'Share your status in one click',
        vmid: 'og:description',
      },
      {
        property: 'og:image',
        content: `${process.env.BASE_URL}thumbnail.png`,
        vmid: 'og:image',
      },
    ],
  },
}
</script>

<template>
  <div id="app">
    <router-view />

    <AppServiceWorkerManager />
  </div>
</template>

<style lang="postcss">
@import '~@/assets/styles/tailwind.postcss';
</style>
